import { IAutomationAppComponent } from "../../types";
import { schema, schemaExhaust, schemaFresh, schemaOutgoing, schemaSupply } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { IconFilter } from "./IconFilter";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: IconFilter,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:     {
        group: 'SubPlants',
        name: "Filter",
        description:  "Filter",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppExhaust : IAutomationAppComponent = {
    schema: schemaExhaust,
    supportsProcessPanel: false,
    Icon: IconFilter,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:     {
        group: 'SubPlants',
        name: "Filter in exhaust duct",
        description:  "Exhaust Filter",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppFresh : IAutomationAppComponent = {
    schema: schemaFresh,
    supportsProcessPanel: false,
    Icon: IconFilter,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:     {
        group: 'SubPlants',
        name: "Filter in fresh air duct",
        description:  "Fresh Air Filter",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppOutgoing : IAutomationAppComponent = {
    schema: schemaOutgoing,
    supportsProcessPanel: false,
    Icon: IconFilter,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:     {
        group: 'SubPlants',
        name: "Filter in outgoing air duct",
        description:  "Outgoing Air Filter",
        panel: OverviewPanel,
        defaultState: { },
    },
}  
export const AppSupply : IAutomationAppComponent = {
    schema: schemaSupply,
    supportsProcessPanel: false,
    Icon: IconFilter,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:     {
        group: 'SubPlants',
        name: "Filter in supply air duct",
        description:  "Supply Air Filter",
        panel: OverviewPanel,
        defaultState: { },
    },
}    